const host = 'http://127.0.0.1:8081'

export default {
  host
}



//////////////////
// WEBPACK FOOTER
// ./static/config/global.js
// module id = null
// module chunks = 